import React from "react";
import { Divider, Table } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Emergencies(props) {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Start Date",
      dataIndex: "disaster_start_date",
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <a onClick={() => navigate("/e/" + record.id)}>{text}</a>
      ),
    },
    {
      title: "Disaster Type",
      dataIndex: "dtypename",
    },
    {
      title: "Glide",
      dataIndex: "glide",
    },
    {
      title: "Requested Amount",
      dataIndex: "areq",
    },
    {
      title: "# Affected",
      dataIndex: "num_affected",
    },
  ];
  const url =
    "https://goadmin.ifrc.org/api/v2/event/?limit=50&ordering=-disaster_start_date&countries__in=194&offset=0";

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.get(url).then((response) => {
      //debugger;
      for (var i = 0; i < response.data.results.length; i++) {
        // eslint-disable-next-line no-unused-expressions
        response.data.results[i].disaster_start_date =
        response.data.results[i].disaster_start_date.substring(0,10);
        response.data.results[i].dtypename = response.data.results[i].dtype.name;
        if(response.data.results[i].appeals && response.data.results[i].appeals.length>0 )
        response.data.results[i].areq = response.data.results[i].appeals[0].amount_requested;
      }

      setPost(response.data);
      console.log(response.data);
    });
  }, []);

  if (!post) return null;

  return (
    <>
      <section>
        <div class="container pt-20 pb-20">
          <div class="section-content">
            <div class="row">
              <div class="col-md-12">
                <div class="tabbable-panel">
                  <Divider orientation="left">
                    <h4>
                      <b>ALL MONGOLIA OPERATIONS ({post.count}</b>)
                    </h4>
                  </Divider>
                  <Table dataSource={post.results} columns={columns} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Emergencies;
